import React from 'react';
import ReactDOM from 'react-dom';
import {ViewType} from "../../gd/const/views/view-type";
const { when, Deferred } = require('simply-deferred');



// const debug = '{ResourceLoader3}'
const debug = false

export default class ResourceLoaderProto{

    public domElementId     : string    = 'ui-page'
    public resourceLoader   : any
    public App              : any

    constructor(params?:any) {

        debug && console.log(debug, "Constructor() params=", params)

        // navernoe ne nuzno
        // this.isResourceLoader = true;

        // this.domElementId = 'ui-page';

        this.resourceLoader = new Deferred();
        this.App = false;

    }

    protected resources(viewType?: ViewType): any {
        throw Error("#094847 Not implemented")
        // return [
        //     this._loadCSS('activity'),
        //     this._loadAPP(appLoaderFunction)
        //     gd.sesstion.crmContacts
        // ];
    }


    load(showLoading = true):Promise<boolean> {

        debug && console.log(debug, "load() showLoading=",showLoading)

        // if (showLoading) this.renderLoading();

        debug && console.log(debug, "resources=", this.resources())

        when(
            this.resources()
        ).then(()=>{
            this.resourceLoader.resolve(this.App);
        }).fail((e:any)=>{
            this.renderErrorLoading();
        });

        return this.resourceLoader;
    }


    _loadCSS(folder:string, file:any=false) {
        debug && console.log(debug, "loadCSS folder=",folder, "file=",file)

        if (!file) file = folder;

        // @ts-ignore
        return gd.skin.loadDeferred(folder, file);
    }

    _loadModule(packFunction:any) {

        debug && console.log(debug, "loadMoule")

        const chunkLoader = new Deferred();

        packFunction().then(()=>{
            chunkLoader.resolve();
        }, (error:any) => {
            console.error(error);
            chunkLoader.reject();
        });

        return chunkLoader;
    }

    _loadChunks(chunks: any) {
        debug && console.log(debug, "_loadChunks")
        const chunkLoader = new Deferred();

        let loaded = 0, keys = _.keys(chunks);
        const chunkLoad = (name: any)=>{
            chunks[name]().then((component: any)=>{
                // @ts-ignore
                this[name] = component.default;
                loaded++;
                if (loaded === keys.length) chunkLoader.resolve();
            });
        };

        keys.map(k=>chunkLoad(k));

        return chunkLoader;
    }


    _loadAPP(packFunction:any) {
        debug && console.log(debug, "loadAPP")

        const chunkLoader = new Deferred();

        packFunction().then((component:any)=>{
            this.App = component.default;
            chunkLoader.resolve();
        }, (error:any) => {
            console.error(error);
            chunkLoader.reject();
        });

        return chunkLoader;
    }


    // seems like we dont need it anymore as we use gd.layout.loading
    renderLoading() {

    }

    renderErrorLoading() {

        ReactDOM.render(
            <div>LOADING APP RESOURCES - ERRORS</div>,
            document.getElementById(this.domElementId)
        );

    }
}